/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  whenCreateOrEditMode,
} from '@gh/common-shared';

import { ScheduleTemplateDetailsInfo } from '../../../resources/scheduling-schedule-template.model';

@Component({
  selector: 'gh-scheduling-schedule-template-details-top-form',
  template: require('./scheduling-schedule-template-details-top-form.component.html'),
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchedulingScheduleTemplateDetailsTopFormComponent extends AbstractSnapshotFormComponent<ScheduleTemplateDetailsInfo>
  implements OnInit {

  constructor(private formStateBuilder: FormStateBuilder) {
    super();
  }

  protected buildForm(snapshot: FormStateSnapshot<ScheduleTemplateDetailsInfo>): FormState<ScheduleTemplateDetailsInfo> {
    return this.formStateBuilder.buildPlain<ScheduleTemplateDetailsInfo>({
      snapshot,
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      children: {
        name: { required: true },
      },
    });
  }
}
